<template>
  <div class="yeekee-container">
    <div class="card mb-1 w-100">
      <div class="card-header bg-dark text-light titlestyle d-flex justify-content-between align-items-center p-2">
        <div>สถิติย้อนหลัง</div>
      </div>
      <b-container class="d-sm-block px-0">
        <div class="row stat-r">
          <div class="title-l">
            2 บน
          </div>
          <div class="col-6 pr-0">
            <div class="yeekee-header d-flex justify-content-center py-2">
              <div class="high circle mx-1 mx-sm-3">สูง</div>
              <div class="low circle mx-1 mx-sm-3">ต่ำ</div>
            </div>
            <div class="yeekee-stat">
              <table class="table table-yeekee">
                <tr v-for="(rowItem, rowIndex) in firstTwoHLList" v-bind:key="rowIndex">
                  <td v-for="(colItem, colIndex) in rowItem.data" v-bind:key="colIndex">
                    <span v-if="colItem.data" class="circle" :class="[colItem.data > 50 ? 'high' : 'low']">
                      {{ colItem.data }}
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="col-6 pl-1">
            <div class="yeekee-header d-flex justify-content-center py-2">
              <div class="even circle mx-1 mx-sm-3">คู่</div>
              <div class="odd circle mx-1 mx-sm-3">คี่</div>
            </div>
            <div class="yeekee-stat">
              <table class="table table-yeekee">
                <tr v-for="(rowItem, rowIndex) in firstTwoEOList" v-bind:key="rowIndex">
                  <td v-for="(colItem, colIndex) in rowItem.data" v-bind:key="colIndex">
                    <span v-if="colItem.data" class="circle" :class="[colItem.data % 2 == 0 ? 'even' : 'odd']">
                      {{ colItem.data }}
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="row stat-r">
          <div class="title-l">
            2 ล่าง
          </div>
          <div class="col-6 pr-0">
            <div class="yeekee-stat">
              <table class="table table-yeekee">
                <tr v-for="(rowItem, rowIndex) in lastTwoHLList" v-bind:key="rowIndex">
                  <td v-for="(colItem, colIndex) in rowItem.data" v-bind:key="colIndex">
                    <span v-if="colItem.data" class="circle" :class="[colItem.data > 50 ? 'high' : 'low']">
                      {{ colItem.data }}
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="col-6 pl-1">
            <div class="yeekee-stat">
              <table class="table table-yeekee">
                <tr v-for="(rowItem, rowIndex) in lastTwoEOList" v-bind:key="rowIndex">
                  <td v-for="(colItem, colIndex) in rowItem.data" v-bind:key="colIndex">
                    <span v-if="colItem.data" class="circle" :class="[colItem.data % 2 == 0 ? 'even' : 'odd']">
                      {{ colItem.data }}
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: "YeekeeStat",
  data() {
    return {
      results: [],
      yeekeeSelected: 0,
      foreignSTKSelected: 0,
      testHLList: [
        11
        , 12
        , 13
        , 14
        , 15
        , 16
        , 17
        , 18
        , 19
        , 20
        , 99
        , 98
        , 97
        , 96
        , 95
        , 21
        , 22
        , 94
        , 93
        , 92
        , 91
        , 90
        , 89
        , 88
        , 23
        , 24
        , 87
        , 86
        , 25
        , 85
        , 26
        , 84
      ],
      testEOList: [
        11
        , 13
        , 15
        , 17
        , 19
        , 21
        , 23
        , 25
        , 27
        , 10
        , 12
        , 14
        , 16
        , 18
        , 20
        , 22
        , 24
        , 26
        , 28
        , 30
        , 29
        , 31
        , 33
        , 32
        , 34
        , 35
        , 36
        , 37
        , 38
      ],
      firstTwoHLList: [],
      lastTwoHLList: [],
      firstTwoEOList: [],
      lastTwoEOList: [],
      yeekeeView: "long"
    };
  },
  mounted() {
    this.getGames();
  },
  methods: {
    getGames() {
      axios
        .post(
          this.getApiUrl + "/pingpong/getavailablepingpongtimetable",
          {
            lottoType: 1
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername
            }
          }
        )
        .then(response => {
          const resultList = response.data.data.map(x => x.resultDice).filter(result => result !== null);

          const firstTwoList = resultList.map(num => num.toString().slice(0, 2));
          const lastTwoList = resultList.map(num => num.toString().slice(3));

          // high low
          this.firstTwoHLList = this.generateStatistics(firstTwoList, "hl");
          this.lastTwoHLList = this.generateStatistics(lastTwoList, "hl");

          // even-odd
          this.firstTwoEOList = this.generateStatistics(firstTwoList, "eo");
          this.lastTwoEOList = this.generateStatistics(lastTwoList, "eo");

          // test data
          // this.firstTwoHLList = this.generateStatistics(this.testHLList, "hl");
          // this.lastTwoHLList = this.generateStatistics(this.testHLList, "hl");
          // this.firstTwoEOList = this.generateStatistics(this.testEOList, "eo");
          // this.lastTwoEOList = this.generateStatistics(this.testEOList, "eo");
        });
    },
    generateStatistics(statistics, mode, maxRow = 6, defaultDisplayColumn = 13, additionalColumn = 1) {
      // mode = hl, eo (hl = high low, eo = even odd)
      const listResult = Array.from({ length: maxRow }, (_, i) => ({ row: i + 1, data: [] }));
      let currentColumn = 1;
      let currentRow = 1;
      let isOverMaxRow = false;

      for (let i = 0; i < statistics.length; i++) {
        let currentRowData = listResult.find(x => x.row === currentRow);
        const currentData = statistics[i];
        const previousData = i > 0 ? statistics[i - 1] : null;

        let isSameDataType = false;
        if (mode === "hl") {
          isSameDataType = previousData && (previousData <= 50) === (currentData <= 50);
        } else if (mode === "eo") {
          isSameDataType = previousData && (previousData % 2 == 0) === (currentData % 2 == 0)
        } else {
          return listResult;
        }

        if (previousData && !isSameDataType) {
          if (isOverMaxRow) {
            isOverMaxRow = false;
            currentRow = 1;
            currentRowData = listResult.find(x => x.row == currentRow);
          } else if (!isOverMaxRow) {
            isOverMaxRow = false;
            currentColumn++;
            currentRow = 1;
            currentRowData = listResult.find(x => x.row == currentRow);
          }

          currentRowData.data.push({ column: currentColumn, data: currentData });
          currentRow = currentRow === maxRow ? 1 : currentRow + 1;
        } else if (previousData && isSameDataType) {
          if (currentRow === 1 && !isOverMaxRow) {
            isOverMaxRow = true;
            currentColumn++;
            currentRow = maxRow;

            currentRowData = listResult.find(x => x.row == currentRow);
            currentRowData.data.push({ column: currentColumn, data: currentData });
          } else if (isOverMaxRow) {
            if (currentRow > 1) {
              currentRow--;

              currentRowData = listResult.find(x => x.row == currentRow);
              currentRowData.data.push({ column: currentColumn, data: currentData });
            } else {
              isOverMaxRow = false;
              currentRow = 1;
              currentColumn++;

              currentRowData = listResult.find(x => x.row == currentRow);
              currentRowData.data.push({ column: currentColumn, data: currentData });

              currentRow++;
            }
          } else {
            const existColumn = currentRowData.data.find(x => x.column === currentColumn);
            if (existColumn) {
              currentRow = 1;
              currentColumn++;
              currentRowData = listResult.find(x => x.row == currentRow);
            }

            currentRowData.data.push({ column: currentColumn, data: currentData });
            currentRow = currentRow === maxRow ? 1 : currentRow + 1;
          }
        } else {
          currentRowData.data.push({ column: currentColumn, data: currentData });
          currentRow = currentRow === maxRow ? 1 : currentRow + 1;
        }
      }

      let maxColumn = Math.max(...listResult[0].data.map(x => x.column));
      if (maxColumn < defaultDisplayColumn) {
        maxColumn = defaultDisplayColumn;
      } else {
        maxColumn = maxColumn + additionalColumn;
      }

      listResult.forEach(rowItem => {
        for (let column = 1; column <= maxColumn; column++) {
          if (!rowItem.data.some(x => x.column === column)) {
            rowItem.data.push({ column: column, data: null });
          }
        }
        rowItem.data.sort((a, b) => a.column - b.column);
      });

      return listResult;
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl"
    })
  },
}
</script>

<style lang="scss" scoped>
.yeekee-container {

  table,
  th,
  td {
    border: 1px solid black;
    border-collapse: collapse;
  }

  .titlestyle {
    font-size: 120%;
    line-height: 1;
  }

  .stat-r {
    position: relative;
    padding-left: 35px;
    margin-bottom: 2px;

    @media screen and (max-width: 767px) {
      padding-left: 30px;
    }
  }

  .title-l {
    position: absolute;
    height: 100%;
    -webkit-transform: rotate(-180deg);
    -moz-transform: rotate(-180deg);
    background: #022224;
    text-align: center;
    z-index: 1;
    writing-mode: vertical-rl;
    font-size: 20px;
    line-height: 35px;
    color: #fff;
    left: 0;
    margin-left: 15px;

    @media screen and (max-width: 767px) {
      font-size: 19px;
      line-height: 30px;
    }
  }

  .yeekee-stat {
    background: #fff;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .yeekee-header {
    background: #032224;

    @media screen and (max-width: 767px) {
      padding: 5px 0 !important;
    }

    .circle {
      width: 30px;
      line-height: 30px;
      text-align: center;

      @media screen and (max-width: 767px) {
        width: 25px;
        line-height: 25px;
      }
    }
  }

  .table-yeekee {
    table-layout: fixed;
    margin-bottom: 0;

    td {
      width: 34px;
      height: 33px;
      padding: 2px;

      @media screen and (max-width: 767px) {
        width: 28px;
        height: 25px;
      }

      &:empty::before {
        content: '\00a0';
        visibility: hidden
      }

      span {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;

        @media screen and (max-width: 767px) {
          font-size: 14px;
        }
      }
    }
  }

  .circle {
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    border-radius: 25px;
  }

  .high {
    background: #0573F5;
    color: #fff;
  }

  .low {
    background: #D83545;
    color: #fff;
  }

  .even {
    background: #26A33F;
    color: #fff;
  }

  .odd {
    background: #F4C006;
    color: #fff;
  }
}
</style>
